import React, { useEffect } from "react";
import SubmitBtn from "./submitButton.jsx";
import useOnScreen from "../hooks/useOnScreen";
import useMediaQuery from "@mui/material/useMediaQuery";
import { scrollToElement } from "../utils/Utils.js";

const baseStyles = {
  top: "auto",
  bottom: 0,
  position: "fixed",
  backgroundColor: "#FFFFFF",
  display: "flex",
  alignItems: "center",
  width: "100%",
  left: "auto",
  right: 0,
  zIndex: 1200,
  boxShadow:
    "rgba(0, 0, 0, 0.2) 0px 2px 4px -1px, rgba(0, 0, 0, 0.14) 0px 4px 5px 0px, rgba(0, 0, 0, 0.12) 0px 1px 10px 0px",
  padding: "15.5px 24px",
};

const StickyButton = (props) => {
  const bookingPanel = document.getElementById("workspace");
  const bookingModal = document.getElementById("BookingModal");
  const isBookingPanelVisible = useOnScreen(bookingPanel);
  const isBookingModalVisible = useOnScreen(bookingModal);
  const buttonMustBeVisible = useMediaQuery("(max-width:767px)");
  const isEventPage = props.context === "Event";
  useEffect(() => {}, [isBookingPanelVisible, buttonMustBeVisible]);
  return (
    <>
      {!isBookingPanelVisible &&
        !isBookingModalVisible &&
        buttonMustBeVisible && (
          <div style={{ ...baseStyles }}>
            <SubmitBtn
              isBottom
              toDoOnClick={() =>
                scrollToElement(
                  props.headerVisible,
                  isEventPage ? "workspace" : "r_ticketsSection",
                )
              }
              buttonText={props.buttonText}
              venueSeatsProp={props.venueSeatsProp}
            />
          </div>
        )}
    </>
  );
};

export default StickyButton;
